import { render, staticRenderFns } from "./AutomationMenu.vue?vue&type=template&id=29106194"
import script from "./AutomationMenu.vue?vue&type=script&lang=js"
export * from "./AutomationMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports